import React from 'react';
import './ProjectSection.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

const ProjectCard = ({ title, description, image, index }) => {
  const cardRef = useScrollAnimation(index * 200);
  
  return (
    <div ref={cardRef} className="project-card animate-on-scroll animate-fade-in-up">
      <h3 className="card-title">{title}</h3>
      <p className="card-description">
        {description}
      </p>
      <div className="card-image">
        <img src={image} alt={title} className="project-img" />
      </div>
    </div>
  );
};

const ProjectSection = () => {
  const headerRef = useScrollAnimation(100);
  
  const projectsData = [
    {
      title: "أنشر",
      description: "اعرض مشروعك اليوم، وشاهد الوكالات تقديم أفضل الحلول المصممة خصيصا لتلبية احتياجاتك",
      image: "/Rectangle 10458.png"
    },
    {
      title: "انتقاء",
      description: "انتق العرض الأمثل لمشروعك من بين أفضل العروض المقدمة خصيصا لك",
      image: "/Rectangle 10463.png"
    },
    {
      title: "المراجعات",
      description: "توصيات تساعدك على معرفة تجارب الآخرين واختيار الأنسب",
      image: "/Rectangle 10489.png"
    }
  ];

  return (
    <section id="project-section" className="project-section">
      <div ref={headerRef} className="project-header animate-on-scroll animate-fade-in-up">
        <h2 className="project-title">
          انشر عرض مشروعك، ودع الوكالات تتنافس لتقديم أفضل الحلول لاحتياجاتك
        </h2>
        <div className="project-quote">
          <span className="quote-mark">"</span>
          فوضى أقل، نشاط أكبر
        </div>
      </div>

      <div className="project-cards">
        {projectsData.map((project, index) => (
          <ProjectCard
            key={index}
            title={project.title}
            description={project.description}
            image={project.image}
            index={index}
          />
        ))}
      </div>
    </section>
  );
};

export default ProjectSection;


